import { useLenis } from 'lenis/react';
import { useReducedMotion } from 'framer-motion';

export function useScrollTo() {
  const lenis = useLenis();
  const reduced = useReducedMotion();
  return (id) => {
    const target = document.getElementById(id);
    if (!target) return;
    if (lenis && !reduced) lenis.scrollTo(target, { offset: -100 });
    else target.scrollIntoView({ behavior: 'instant', block: 'start' });
  };
}
